import React from 'react'
import styled from 'styled-components'
import {
  space,
  width,
  color,
  flex,
  order,
  fontSize,
  alignSelf,
  flexWrap,
  flexDirection,
  alignItems,
  justifyContent,
  borders,
  minWidth,
  minHeight,
  borderRadius,
  size,
  height,
  maxWidth,
  maxHeight,
  textAlign,
  boxShadow,
  borderColor,
  position,
  display,
  top,
  bottom,
  left,
  right,
  zIndex,
  overflow
} from 'styled-system'

// Note that Box and Flex have 100% width by default
export const Box = styled.div`
  ${position};
  ${width};
  ${space};
  ${fontSize};
  ${color};
  ${flex};
  ${order};
  ${alignSelf};
  ${borders};
  ${borderColor};
  ${minWidth};
  ${minHeight};
  ${borderRadius};
  ${size};
  ${height};
  ${textAlign};
  ${maxWidth};
  ${maxHeight};
  ${boxShadow};
  ${display};
  ${top};
  ${bottom};
  ${left};
  ${right};
  ${zIndex};
  ${overflow};
  @media (max-width: 700px) {
    ${(props) => props.pxm && `padding-right:${props.pxm};padding-left:${props.pxm};`};
    ${(props) => props.mxm && `margin-right:${props.mxm};margin-left:${props.mxm};`};
    ${(props) => props.mrm && `margin-right:${props.mrm};`};
    ${(props) => props.widthm && `width:${props.widthm};`};
    ${(props) => props.heightm && `height:${props.heightm};`};
    ${(props) => props.flexDirectionm && `flex-direction:${props.flexDirectionm};`};
  }
`

export const Flex = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};
  ${flexWrap};
  ${flexDirection};
  ${alignItems};
  ${justifyContent};
  ${width};
`

export const Ul = styled.ul`
  list-style: disc;
  margin-left: 30px;
`

export const MobileContainer = styled(Flex)`
  display: none;
  @media (max-width: 700px) {
    display: flex;
  }
`

export const DesktopContainer = styled(Flex)`
  @media (max-width: 700px) {
    display: none;
  }
`
